import script from "./LeftContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftContainer.vue?vue&type=script&lang=ts&setup=true"

import "./LeftContainer.vue?vue&type=style&index=0&id=60b3e0fc&lang=scss"

const __exports__ = script;

export default __exports__